
















































































































































import { PropType } from 'vue';
import {
  EWheelOfFortuneCampaignActivationType,
  EWheelOfFortuneCampaignStatusType,
  IWheelOfFortuneCampaignFiltersParams
} from '@/api/schema';
import pickBy from 'lodash/pickBy';

const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const BaseDialog = (): Promise<any> => import('@/components/BaseDialog.vue');
const VExtendedDataPicker = (): Promise<any> =>
  import('@/components/VExtendedDataPicker.vue');

const defaultFilters = {
  activation: null,
  createdAfter: null,
  createdBefore: null,
  startAfter: null,
  startBefore: null,
  finishAfter: null,
  finishBefore: null,
  status: []
};

export default {
  name: 'CopyStakeWheelOfFortuneCampaignsTableFiltersDialog',
  components: {
    BaseDialog,
    VExtendedDataPicker,
    VStatus
  },
  props: {
    value: {
      type: Boolean,
      default: (): boolean => false
    },
    filters: {
      type: Object as PropType<IWheelOfFortuneCampaignFiltersParams> | null,
      default: { ...defaultFilters }
    }
  },
  data(): any {
    return {
      isFormValid: false,
      formData: { ...defaultFilters },

      activateTypes: [
        {
          value: EWheelOfFortuneCampaignActivationType.BY_OPERATOR,
          label: 'Operator'
        },
        {
          value: EWheelOfFortuneCampaignActivationType.BY_STREAMER,
          label: 'Streamer'
        }
      ],
      statusCheckboxesConfig: [
        {
          label: 'Finished',
          type: 'additional-finished',
          value: EWheelOfFortuneCampaignStatusType.FINISHED
        },
        {
          label: 'Running',
          type: 'system-success',
          value: EWheelOfFortuneCampaignStatusType.ACTIVE
        },
        {
          label: 'Pending',
          type: 'additional-pending',
          value: EWheelOfFortuneCampaignStatusType.PENDING
        }
        // Temporarily hidden
        // {
        //   label: 'Deleted',
        //   type: 'additional-deleted',
        //   value: EWheelOfFortuneCampaignStatusType.DELETED
        // }
      ]
    };
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    isDisabledSubmitBtn(): boolean {
      return !this.isFormValid;
    }
  },
  methods: {
    handlerClickSubmitButton(): void {
      let newFilters = pickBy(
        this.formData,
        (value) =>
          value !== null &&
          value !== '' &&
          (!Array.isArray(value) || value.length > 0)
      );

      newFilters = Object.keys(newFilters).length > 0 ? newFilters : null;

      this.$emit('update:filters', newFilters);

      this.closeDialog();
    },
    handlerClickCleanBtn(): void {
      this.resetForm();
    },
    handlerClickCloseBtn(): void {
      this.closeDialog();
    },
    resetForm(): void {
      this.formData = {
        ...defaultFilters
      };
    },
    async closeDialog(): Promise<void> {
      this.$emit('close');
      this.showDialog = false;

      this.$nextTick(() => {
        this.formData = this.filters
          ? {
              status: [],
              ...this.filters
            }
          : { ...defaultFilters };
      });
    }
  }
};
